module.exports = __webpack_public_path__ + "img/product-chuti-qt-04.b7ba50f1.png";